import React, { useState, useEffect, useCallback } from "react";

import InputForms from "components/UiComponents/forms/InputForms";
import { FaUserAlt } from "react-icons/fa";
import { AiOutlineMail, AiFillLock } from "react-icons/ai";
import Button from "components/UiComponents/Button";
import { MdRefresh } from "react-icons/md";
import styles from "./StepAccount.module.scss";
import InputPassword from "components/UiComponents/forms/InputPassword";


const StepAccount = ({ userData, updateUserData, triggerValidation }) => {

    const [validation, setValidation] = useState("");
    const [validationType, setValidationType] = useState(""); // 'error' ou 'success'

    const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

    // Fonction de validation qui peut être appelée depuis l'extérieur
    const validateStep = useCallback(() => {
        // Validation des champs requis : login, email, mot de passe
        if (!userData.login || !userData.email || !userData.password) {
            let missingFields = [];
            if (!userData.login) missingFields.push("Login");
            if (!userData.email) missingFields.push("Email");
            if (!userData.password) missingFields.push("Mot de passe");
            
            setValidation(`Les champs suivants sont obligatoires : ${missingFields.join(", ")}`);
            setValidationType("error");
            return false;
        }

        // Validation de l'email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(userData.email)) {
            setValidation("Veuillez saisir un email valide.");
            setValidationType("error");
            return false;
        }

        // Valider et passer à l'étape suivante
        setValidation("Informations du compte validées !");
        setValidationType("success");
        
        return true;
    }, [userData.login, userData.email, userData.password]);

    // Écouter le déclencheur de validation du parent
    useEffect(() => {
        if (triggerValidation > 0) {
            validateStep();
        }
    }, [triggerValidation, validateStep]);

    const generatePassword = () => {
        console.log("Génération du mot de passe...");
        const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
        const passwordLength = 12;
        let generatedPassword = "";
        for (let i = 0; i < passwordLength; i++) {
            generatedPassword += chars.charAt(
                Math.floor(Math.random() * chars.length)
            );
        }

        console.log("Mot de passe généré:", generatedPassword);
        updateUserData({ password: generatedPassword });
        setValidation(""); // Réinitialise les validations après génération
        setValidationType("");
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        validateStep();
    };





    return (
        <div>
            <form onSubmit={handleSubmit} className={styles.formContainer}>
                {validation && (
                    <p className={`${styles.validationMessage} ${styles[validationType]}`}>
                        {validation}
                    </p>
                )}
                <InputForms
                    type="text"
                    placeholder="Login"
                    value={userData.login}
                    onChange={(e) => updateUserData({ login: e.target.value })}
                    required
                    svg={<FaUserAlt />}
                />

                <InputForms
                    type="email"
                    placeholder="Email"
                    value={userData.email}
                    onChange={(e) => updateUserData({ email: e.target.value })}
                    required
                    svg={<AiOutlineMail />}
                />

                <InputForms
                    type="text"
                    placeholder="Nom"
                    value={userData.lastName}
                    onChange={(e) => updateUserData({ lastName: capitalize(e.target.value) })}
                    required
                    svg={<FaUserAlt />}
                />

                <InputForms
                    type="text"
                    placeholder="Prénom"
                    value={userData.name}
                    onChange={(e) => updateUserData({ name: capitalize(e.target.value) })}
                    required
                    svg={<FaUserAlt />}
                />

                <div className={styles.passwordContainer}>
                    <InputPassword
                        placeholder={userData.password !== "" ? userData.password : "Mot de passe"}
                        value={userData.password}
                        onChange={(e) => updateUserData({ password: e.target.value })}
                        required
                    />
                    <Button
                        type="button"
                        onPress={generatePassword}
                        text="Générer"
                        svg={<MdRefresh />}
                        styles={"btnPrimary"}
                    />
                </div>
            </form>

        </div>
    );
}

export default StepAccount;
